import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=7cca36ca&scoped=true"
import script from "./TaskIndex.vue?vue&type=script&lang=js"
export * from "./TaskIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskIndex.vue?vue&type=style&index=0&id=7cca36ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca36ca",
  null
  
)

export default component.exports